import Link from "next/link";
import { 헤더_DesktopAB } from "./헤더_DesktopAB";
import { 푸터_Desktop } from "./푸터_Desktop";
import 섹션1_이미지 from "/public/assets/pc/images/pic/img_section1_bg_marketbomdome1.webp";
import 섹션2_이미지1 from "/public/assets/pc/images/pic/img_section2_marketbomdome1.webp";
import 섹션2_이미지2 from "/public/assets/pc/images/pic/img_section2_marketbomdome2.webp";
import 섹션2_이미지3 from "/public/assets/pc/images/pic/img_section2_marketbomdome3.webp";
import 섹션2_이미지4 from "/public/assets/pc/images/pic/img_section2_marketbomdome4.webp";
import 섹션2_이미지5 from "/public/assets/pc/images/pic/img_section2_marketbomdome5.webp";
import 섹션2_이미지6 from "/public/assets/pc/images/pic/img_section2_marketbomdome6.webp";
import 화살표_아이콘 from "/public/assets/pc/images/icon/icon_move_link1.webp";
import { 무료체험기간 } from "./데이터/무료체험기간";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";

export const 마켓봄도매소개_Desktop = () => {
  const tracker = useTracker();
  return (
    <div id="wrap">
      <헤더_DesktopAB />
      <div id="container" className="service-infomation service-marketbomdome">
        <h2 className="blind">본문 내용</h2>
        <div
          className="section section1"
          style={{
            background: `url(${섹션1_이미지.src}) no-repeat center center #f4f7fa`,
          }}
        >
          <h3 className="blind">상단 소개</h3>
          <div className="inner">
            <dl>
              <dt>마켓봄 도매</dt>
              <dd>
                현장 판매가 주를 이루는 중도매인, 상회, 중상업자가
                <br />
                사용하기에 적합한 판매관리 프로그램입니다.
              </dd>
            </dl>
          </div>
        </div>
        <div className="section section2">
          <div className="inner">
            <h3>아직도 이런 문제를 가지고 계신가요?</h3>
            <div
              className="row type1"
              style={{
                background: `url(${섹션2_이미지1.src}) no-repeat right center`,
              }}
            >
              <span className="num open-sans">01</span>
              <dl>
                <dt>
                  번거로운
                  <strong className="bold"> 현장 판매 후 판매 취합</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은
                    <strong className="bold"> 모바일로 즉시 등록</strong>
                  </span>
                </dt>
                <dd>
                  판매 등록용 모바일 앱 제공으로 현장에서
                  <br />
                  즉시 판매등록이 가능합니다.
                </dd>
              </dl>
            </div>
            <div
              className="row type2"
              style={{
                background: `url(${섹션2_이미지2.src}) no-repeat left center`,
              }}
            >
              <span className="num open-sans">02</span>
              <dl>
                <dt>
                  복잡한 <strong className="bold">판매/구매 관리</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은 POS로 <strong className="bold">간편 관리</strong>
                  </span>
                </dt>
                <dd>
                  POS전용화면으로 터치만으로
                  <br />
                  판매,구매 등록이 가능합니다.
                </dd>
              </dl>
            </div>
            <div
              className="row type3"
              style={{
                background: `url(${섹션2_이미지3.src}) no-repeat right center`,
              }}
            >
              <span className="num open-sans">03</span>
              <dl>
                <dt>
                  실시간으로 확인이 어렵던
                  <strong className="bold"> 매입/매출 조회</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은
                    <strong className="bold"> 모바일앱으로 즉시 확인</strong>
                  </span>
                </dt>
                <dd>
                  매출 확인용 모바일 앱 제공으로 실시간으로
                  <br />
                  매출과 매입의 상세 내역까지 확인 할 수 있습니다.
                </dd>
              </dl>
            </div>
            <div
              className="row type4"
              style={{
                background: `url(${섹션2_이미지4.src}) no-repeat left center`,
              }}
            >
              <span className="num open-sans">04</span>
              <dl>
                <dt>
                  반복되는 <strong className="bold">일과후 영수증 등록</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은 <strong className="bold">자동등록</strong>
                  </span>
                </dt>
                <dd>
                  마켓봄으로 판매 등록 시 영수증 등록, 출력,
                  <br />
                  장부작성, 전표등록 까지 자동으로 전산입력됩니다.
                </dd>
              </dl>
            </div>
            <div
              className="row type5"
              style={{
                background: `url(${섹션2_이미지5.src}) no-repeat left center`,
              }}
            >
              <span className="num open-sans">05</span>
              <dl>
                <dt>
                  번거로운 <strong className="bold">세금계산서 발행</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은 <strong className="bold">원클릭 발행</strong>
                  </span>
                </dt>
                <dd>
                  판매된 주문을 자동 취합하여
                  <br />
                  거래명세표와 비교할 필요없이 원클릭으로
                  <br />
                  세금계산서를 발행합니다.
                </dd>
              </dl>
            </div>
            <div
              className="row type6"
              style={{
                background: `url(${섹션2_이미지6.src}) no-repeat right center`,
              }}
            >
              <span className="num open-sans">06</span>
              <dl>
                <dt>
                  복잡한 <strong className="bold">시재금관리</strong>
                  <br />
                  <span className="fc1">
                    마켓봄은 <strong className="bold">간단등록</strong>
                  </span>
                </dt>
                <dd>
                  유통사 주문확인용
                  <strong className="bold"> 모바일 앱 제공</strong>으로
                  <br />
                  실시간으로 매출과 매입의 상세내역까지
                  <br />
                  확인할 수 있습니다.
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div className="section section3">
          <div className="inner">
            <h3>다양한 마켓봄 도매의 기능</h3>

            <div className="function-list">
              <div className="row type1">
                <h4>
                  <span className="table-cell">판매/구매</span>
                </h4>
                <div className="cont">
                  <div className="col">
                    <ul>
                      <li>POS화면으로 간단한 판매등록</li>
                      <li>POS화면으로 간단한 구매등록</li>
                      <li>판매 수정, 반품, 삭제</li>
                      <li>구매 수정, 반품, 삭제</li>
                      <li>결제관리</li>
                      <li>일일 마감시간 설정으로 마감관리</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>영수증 출력</li>
                      <li>작업서 출력</li>
                      <li>거래명세서 출력</li>
                      <li>판매내역 조회</li>
                      <li>구매내역 조회</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>판매 등록 전용 모바일 앱 제공</li>
                      <li>구매 등록 전용 모바일 앱 제공</li>
                      <li>판매 조회 전용 모바일 앱 제공</li>
                      <li>구매 조회 전용 모바일 앱 제공</li>
                      <li>거래명세표 카카오톡 발송</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row type2">
                <h4>
                  <span className="table-cell">상품</span>
                </h4>
                <div className="cont">
                  <div className="col">
                    <ul>
                      <li>개별 등록</li>
                      <li>일괄 등록</li>
                      <li>단위 설정</li>
                      <li>단위 설정으로 판매가 자동 환산</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>상품의 카테고리 설정</li>
                      <li>상품 노출 순서 변경</li>
                      <li>자동 환산으로 재고 관리</li>
                      <li>재고 개별 수정</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>재고 일괄 수정</li>
                      <li>재고 금액 관리</li>
                      <li>상품 수불 원장 제공</li>
                      <li>구역 관리</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row type3">
                <h4>
                  <span className="table-cell">회계</span>
                </h4>
                <div className="cont">
                  <div className="col">
                    <ul>
                      <li>판매 단가 일괄수정</li>
                      <li>상품단위별 단가 자동 환산</li>
                      <li>상품단위별 단가 별도 등록</li>
                      <li>상품별 특단가 관리</li>
                      <li>거래처별 특단가관리</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>회계전표 등록</li>
                      <li>시재금 관리</li>
                      <li>다양한 양식의 원장 제공</li>
                      <li>이익율, 손익현황 제공</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>추가 경비 등록</li>
                      <li>국세청 양식의 세금계산서 파일 제공</li>
                      <li>추가 작업없이 세금계산서 즉시 발행</li>
                      <li>세금계산서 비교표 제공</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row type4">
                <h4>
                  <span className="table-cell">거래처</span>
                </h4>
                <div className="cont">
                  <div className="col">
                    <ul>
                      <li>거래처(판매처,구매처) 개별 등록</li>
                      <li>구매처(판매처,구매처) 일괄 등록</li>
                      <li>매출처 카테고리 설정</li>
                      <li>거래처 노출 순서 변경</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>판매처별 초기 잔액(외상액) 설정</li>
                      <li>구매처별 초기 잔액(지급액) 설정</li>
                      <li>판매처별 외상 관리</li>
                      <li>구매처별 미지급 관리</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>매출처 카테고리별 원장 관리</li>
                      <li>매출처별 고정단가, 변동단가 설정</li>
                      <li>“일반”거래처를 통한 현장판매</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row type5">
                <h4>
                  <span className="table-cell">서비스</span>
                </h4>
                <div className="cont">
                  <div className="col">
                    <ul>
                      <li>
                        온라인형식으로 언제어디서든
                        <br />
                        접속가능
                      </li>
                      <li>서버에 데이터 저장하여 관리</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>중복로그인으로 동시 작업</li>
                      <li>POS전용 화면으로 손쉬운 조작</li>
                      <li>WEB전용 화면으로 추가 업무</li>
                    </ul>
                  </div>
                  <div className="col">
                    <ul>
                      <li>모바일 앱으로 업무 대체 가능</li>
                      <li>초기비용없이 즉시 이용 가능</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="btn-wrap">
              <Link
                href={링크.마켓봄도매_회원가입}
                onClick={() => {
                  tracker.trackingClick({
                    depth1: "POSBOM",
                    depth2: "회원가입",
                    depth3: "마켓봄 도매",
                  });
                }}
                style={{
                  background: `url(${화살표_아이콘.src}) no-repeat 463px center #fe6b37`,
                }}
              >
                마켓봄 도매 시작하기
                <span>{`결제없이! ${무료체험기간.마켓봄도매} 무료 이용하기`}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <푸터_Desktop />
    </div>
  );
};
